import { forwardRef } from "react";

const InputField = forwardRef((props, ref) => {
    return (
        <div className={props.divClass ? props.divClass : "mb-3"}>
            <label htmlFor={props.name} className="form-label bold-label">
                {props.title}
            </label>
            {props.required ? <input
                type={props.type}
                className={props.className}
                id={props.name}
                ref={ref}
                name={props.name}
                placeholder={props.placeholder}
                onChange={props.onChange}
                autoComplete={props.autoComplete}
                value={props.value}
                step={props.step}
                required
            /> : <input
                type={props.type}
                className={props.className}
                id={props.name}
                ref={ref}
                name={props.name}
                placeholder={props.placeholder}
                onChange={props.onChange}
                autoComplete={props.autoComplete}
                value={props.value}
                step={props.step}
            /> }
            
            <div className={props.errorDiv}>{props.errorMsg}</div>
        </div>
    )
})

export default InputField;